import React, { ReactElement } from 'react';
import { useSelector } from '@ecommerce/nest-ssr/common';

import type { ReviewStatsMonthlyInterface } from 'interfaces/review-stats.interface';
import CompanyViewCardRatingChartItem from 'components/company-view/company-view-card/rating/chart/chart-item';

import './chart.scss';

interface CompanyViewCardRatingChartProperties {
    activeTab: number;
}

const CompanyViewCardRatingChart: React.FC<CompanyViewCardRatingChartProperties> = ({ activeTab }): ReactElement => {
    const stats = useSelector((state: {
        reviewStatsMonthly: ReviewStatsMonthlyInterface[];
        reviewStatsMonthlyCredible: ReviewStatsMonthlyInterface[];
    }) => ({
        reviewStatsMonthly: state.reviewStatsMonthly,
        reviewStatsMonthlyCredible: state.reviewStatsMonthlyCredible
    }));

    let reviewStatsMonthly: ReviewStatsMonthlyInterface[] = [];

    if (activeTab === 0) {
        reviewStatsMonthly = stats.reviewStatsMonthly;
    } else {
        reviewStatsMonthly = stats.reviewStatsMonthlyCredible;
    }

    const bars = reviewStatsMonthly.length > 0 && reviewStatsMonthly.map(item => (
        <CompanyViewCardRatingChartItem key={`${item.year}${item.month}`} data={item}/>
    ));

    return (
        <div className="company-view-card__rating-chart">
            <p className="company-view-card__rating-chart-title">
                Historia ocen z ostatnich 12 miesięcy
            </p>
            <div className="company-view-card__rating-chart-container">
                {bars || <div className="company-view-card__rating-chart-no-history">brak historii ocen</div>}
            </div>
        </div>
    );
};

export default CompanyViewCardRatingChart;
